import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const defaultSliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
 autoplay: false, 
  pauseOnHover: true,
 autoplaySpeed: 4000,
  speed: 5000,  
  cssEase: "ease",
  slidesToShow: 4,
  centerMode: false,
  centerPadding: "0px",
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1180, settings: { slidesToShow: 3 } },
    { breakpoint: 991, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
};

export default function HomeService({ data, sectionClass }) {
  const { title,  items } = data;
    const sliderRef = useRef(null);
    const sectionRef = useRef(null);

    
      useEffect(() => {
        let autoplayTimer = null;
    
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (!sliderRef.current) return;
    
            if (entry.isIntersecting) {
              // 👉 always show first slide
              sliderRef.current.slickPause();
              sliderRef.current.slickGoTo(0, true);
    
              // 👉 start autoplay after 5 seconds
              autoplayTimer = setTimeout(() => {
                sliderRef.current?.slickPlay();
              }, 4000);
            } else {
              // 👉 stop autoplay if out of view
              sliderRef.current.slickPause();
              if (autoplayTimer) clearTimeout(autoplayTimer);
            }
          },
          { threshold: 0.4 }
        );
    
        if (sectionRef.current) observer.observe(sectionRef.current);
    
        return () => {
          observer.disconnect();
          if (autoplayTimer) clearTimeout(autoplayTimer);
        };
      }, []);



  return (
    <section className={`home-industries ${sectionClass || ""}`} ref={sectionRef}>
      <div className="container">
        {/* Heading Section */}
        {(title) && (
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-7">
              <div className="industries-text center-heading">
                {title && <h3 className="heading heading-center">{title}</h3>}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Slider Section */}
      <div className="container">
        <div className="slider-container">
          <Slider {...defaultSliderSettings} className="industries-slider" ref={sliderRef}>
            {items.map((item, index) => (
              <div className="industries-col" key={index}>
                <div className="industries-col-inner">
                  <div className="industries-heading" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <p>{item.desc}</p>
                  <div className="industries-images">
                    <img src={item.img} alt={item.title} className="img-responsive" loading="lazy" />
                  </div>
                  <div className="industries-btn">
                    <Link to={item.link1} className="default-btn"><span>{item.btn1}</span></Link>
                    <Link to={item.link2} className="default-btn white-btn"><span>{item.btn2} </span></Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}


